import React, { useEffect } from 'react';
import { defaults, Line, Bar, Doughnut } from 'react-chartjs-2';
import { fontString } from 'chart.js/helpers';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import api from './../../../services/axios'
import Loading from './../../../compoments/Loading';
import NavBack from './../../NavBack';
import {renderGrafico} from '../graficosutil'
import DatePicker from './../../../compoments/DatePicker';


const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    backgroundColor: '#F2F2F2',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Tudo() {  
  defaults.font.size = 24
  const  [open, setOpen] = React.useState(false);
  const graficos = ['volAtdGeral','volAtdUsuario','tiposPausa','tempoMedio']
  const titleHeader = 'Voltar'
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);

  var [grafico, setGrafico] = React.useState(graficos[0])
  var [timeSwitch, setTimeSwitch] = React.useState(60)
  var [interval, setTimer] = React.useState(0)
  var time = 30
  
  
  const dateToString = (date, time, format = false) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    
    let timeString = '';
    if (time) {
      timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    }
    if (!format) {
      return yyyy + '-' + mm + '-' + dd + '' + timeString;
    }
    return dd + '/' + mm + '/' + yyyy + ' ' + timeString;
  }

  const addDays = function (date, daysToAdd) {
    var _24HoursInMilliseconds = 86400000;
    return new Date(date.getTime() + daysToAdd * _24HoursInMilliseconds);
  }
  
  const loadData = async () => {
    setLoading(true)
    const { data } = await api.get('v1/graficos/'+grafico+'?start=' + start + '&end='+end)
    setLoading(false)
    setDa(data)    
  }
  const trocaTela = () => {    
    graficos.push(graficos.shift())
    grafico = graficos[0]
    setDa(null)
    setGrafico(graficos[0])
    loadData()
  }
  useEffect(() => {
    var now = new Date()
    var start = new Date()

    start.setDate(now.getDate() - 30)
    setStart(start.toISOString().substring(0,10))
    setEnd(now.toISOString().substring(0,10))

    loadData()
    setTimer(setInterval(trocaTela, timeSwitch * 1000))
    return () => {
      clearInterval(interval)
    }
  }, [])
  var changeSlider = (evt)=>{
    setTimeSwitch(evt.target.value)
    timeSwitch = evt.target.value

    clearInterval(interval)
    setTimer(setInterval(trocaTela, timeSwitch * 1000))    
  }
  

  const [da, setDa] = React.useState(null);
  var [start, setStart] = React.useState("");
  var [end, setEnd] = React.useState("");
  
  const changeTime = function(value,t){
    if(t == 'start'){
      setStart(value)
      start = value
    }else{
      setEnd(value)
      end = value
    }
    loadData()
    
    clearInterval(interval)
    setTimer(setInterval(trocaTela, timeSwitch * 1000))
  }
  return (
    <>
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <NavBack
          titleHeader={titleHeader}
        />        
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} >
          <Container maxWidth={false} className={classes.container}>            
            <div style={{ padding: '64px 40px',height:'80vh'}}>     
                <>
                  <div className='header' style={{ paddingTop: 20,height: '10rem' }}>
                    <h1 className='title'>
                      {grafico == "volAtdGeral" ? "Volume de atendimento geral" : ""}
                      {grafico == "volAtdUsuario" ? "Volume de atendimento por usuário" : ""}
                      {grafico == "tiposPausa" ? "Pausas" : ""}
                      {grafico == "tempoMedio" ? "TMA e TME" : ""}
                    </h1>
                    Tempo em cada tela: <input type="range" min="10" max="60" onChange={changeSlider} value={timeSwitch} /> {timeSwitch} s &nbsp;
                    Do dia&nbsp;
                    <input type="date" onChange={(e)=>changeTime(e.target.value,'start')} value={start} />&nbsp;
                    até o dia&nbsp;
                    <input type="date" onChange={(e)=>changeTime(e.target.value)} value={end} />
                  </div>
                  {loading ? <Loading /> :
                    <div style={{height: '100%',maxHeight:'100%',}}>
                      {renderGrafico(grafico,da)}
                    </div>}
                </>
            </div>
          </Container>
        </div>
      </main>
    </>
  )
}